import React from 'react'
import PropTypes from 'prop-types'

import QuipGuide from './quip'
import ConfluenceGuide from './confluence'
import EvernoteGuide from './evernote'
import { Text } from 'components/base'

const Guides = {
  quip: QuipGuide,
  confluence: ConfluenceGuide,
  evernote: EvernoteGuide,
}

class ImportGuide extends React.Component {
  static propTypes = {
    serviceName: PropTypes.string.isRequired,
  }

  render() {
    const Guide = Guides[this.props.serviceName]
    return (
      <section style={{ maxHeight: 300, overflow: 'auto' }}>
        <Text.Title className="margin-bottom-small">How to import</Text.Title>

        <Guide
          className="shade-20 font-family-system"
          style={{ lineHeight: '21px' }}
        />
      </section>
    )
  }
}

export default ImportGuide
